import React from 'react'
import { Box } from '@mui/material'
import Navigation from './Navigation'
import { useThemeMode } from '../context/ThemeModeContext'
import { useTranslation } from 'react-i18next'

type LayoutProps = {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { mode, toggleMode } = useThemeMode()
  const { i18n } = useTranslation()
  const [language, setLanguage] = React.useState<string>(() => {
    if (typeof window === 'undefined') {
      return 'de'
    }

    const stored = window.localStorage.getItem('wg_lang')
    return stored ?? 'de'
  })

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('wg_lang', language)
    }
    void i18n.changeLanguage(language)
  }, [language, i18n])

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
      <Navigation
        currentLanguage={language}
        onLanguageChange={setLanguage}
        themeMode={mode}
        onToggleTheme={toggleMode}
      />

      <Box component="main" sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </Box>
  )
}

export default Layout
